import routes from "./routes";
import { MdDashboard } from "react-icons/md";
import { PiBuildingsFill } from "react-icons/pi";
import { FaUsers } from "react-icons/fa";
import { GiArchiveRegister } from "react-icons/gi";
import { FaGraduationCap } from "react-icons/fa6";
import { GiPayMoney } from "react-icons/gi";
import { ImExit } from "react-icons/im";
import { BiSolidBank } from "react-icons/bi";
import { RiRefund2Line } from "react-icons/ri";
import { TbFilePercent } from "react-icons/tb";
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import { CgProfile } from "react-icons/cg";
import { IoGameController } from "react-icons/io5";
import { FaSackDollar } from "react-icons/fa6";

export const LOOK_UP_TYPE = {
  gender: "gender",
  prefix: "prefix",
  paymentMode: "paymentmode",
  bloodGroup: "bgroup",
  maritalstatus: "maritalstatus",
  recruitmentMode: "recruitment_mode",
  DLType: "DL_Type",
  country: "country",
  state: "state",
  holidayType: "holiday_type",
  leaveYearType: "leave_year_type",
};

// admin sidebar
export const ADMIN_SIDEBAR_NAV_MENU_ITEMS = {
  subMenu: [
    {
      name: "Dashboard",
      icon: <MdDashboard className="icons-dashboard me-2" />,
      path: routes.dashboard,
    },
    {
      name: "Company",
      icon: <PiBuildingsFill className="icons-dashboard me-2" />,
      path: routes.company.companyInfo,
    },
    {
      name: "Masters",
      icon: <FaGraduationCap className="icons-dashboard me-2" />,
      children: [
        // { name: "Gender", path: routes.master.gender },
        // { name: "Attendance Source", path: routes.master.source },
        { name: "Branch", path: routes.master.branch },
        { name: "Bank", path: routes.master.bank },
        { name: "Bonus", path: routes.master.bonus },
        { name: "Cost Center", path: routes.master.costCenter },
        { name: "Category", path: routes.master.category },
        { name: "Division", path: routes.master.division },
        { name: "Department", path: routes.master.department },
        { name: "Designation", path: routes.master.designation },
        { name: "Document Type", path: routes.master.documentType },
        { name: "Grade", path: routes.master.grade },
        { name: "Location", path: routes.master.location },
        { name: "Project", path: routes.master.project },
        { name: "Qualification", path: routes.master.qualification },
        { name: "Skills", path: routes.master.skills },
        { name: "Essentials", path: routes.master.essentials },
        { name: "Cron", path: routes.master.cron },
        { name: "Emp. Code Category", path: routes.master.empCodeCategory },
      ],
    },
    {
      name: "Employees",
      icon: <FaUsers className="icons-dashboard me-2" />,
      children: [
        { name: "employees", path: routes.employee.listEmployeeNew },
        {
          name: "Employee Confirm.",
          path: routes.employeeConfirmation.listEmployeeConfirm,
        },
        {
          name: "Promotion and Transfer",
          path: routes.payroll.PromotionAndTransferEmpList,
        },
      ],
    },
    {
      name: "Attendance & Leave",
      icon: <GiArchiveRegister className="icons-dashboard me-2" />,
      children: [
        {
          name: "Shift",
          children: [
            { name: "Shift Settings", path: routes.shift.list },
            { name: "Shift Assigned", path: routes.shift.shiftAssign },
          ],
        },
        {
          name: "Attendance",
          children: [
            {
              name: "Attendance Summary",
              path: routes.attendance.attendanceList,
            },
            {
              name: "Attendance Log",
              path: routes.attendance.attendanceLogList,
            },
            { name: "Log Import", path: routes.attendance.LogImport },
            { name: "Auto Attendance", path: routes.attendance.autoAttendance },
          ],
        },

        {
          name: "Leave",
          children: [
            { name: "Leave Type", path: routes.leave.leaveType },
            { name: "Leave Settings", path: routes.leave.leaveSetting },
            { name: "Manual Leave", path: routes.leave.manualLeave },
            { name: "Leave Approval", path: routes.leave.leaveApproval },
            { name: "Leave Reports", path: routes.leave.leaveReport },
          ],
        },
        {
          name: "Holiday",
          children: [
            { name: "Holiday Type", path: routes.leave.holidayType },
            { name: "Holiday Setting", path: routes.leave.holiday },
          ],
        },
      ],
    },

    {
      name: "Assets",
      icon: <GiPayMoney className="icons-dashboard me-2" />,
      children: [
        { name: "Assets Group", path: routes.assets.AssetGroup },
        { name: "Assets List", path: routes.assets.AssetList },
        { name: "In-Store Assets", path: routes.assets.inStoreAssetsList },
        { name: "Assets Issue List", path: routes.assets.issueList },
        { name: "Assets Request List", path: routes.assets.requestList },
      ],
    },
    {
      name: "Salary",
      icon: <FaSackDollar className="icons-dashboard me-2" />,
      children: [
        {
          name: "Payroll",
          children: [
            { name: "Type Of Head", path: routes.payroll.TypeOfHead },
            {
              name: "Earning Head",
              path: routes.payroll.EarningSalaryHead,
            },
            { name: "Deduction Head", path: routes.payroll.DeductionHead },
            { name: "Other Head", path: routes.payroll.OtherHead },
            { name: "LWF Rule Setting", path: routes.payroll.LwfRuleSetting },
            { name: "Professional Tax", path: routes.payroll.ProfessionalTax },
            { name: "CTC Component", path: routes.payroll.CtcComponentSetting },
            { name: "Salary Structure", path: routes.payroll.SalaryStructure },
          ],
        },
        {
          name: "Monthly Calculation",
          children: [
            {
              name: "Earning Variables",
              path: routes.monthlyCalculation.earningVariables,
            },
            {
              name: "Deduction Variables",
              path: routes.monthlyCalculation.deductionVariable,
            },

            {
              name: "Arrear",
              path: routes.monthlyCalculation.IncrementArrear,
            },
            // { name: "Lwp Arrear", path: routes.payroll.LwpArrear },
            // { name: "Other Arrear", path: routes.payroll.OtherArrear },
          ],
        },
        {
          name: "Additional Calculation",
          children: [
            {
              name: "Bonus Calculation",
              path: routes.payroll.BonusCalculation,
            },
            {
              name: "Gratuity Calculation",
              path: routes.payroll.GrautityCalculation,
            },
            {
              name: "Over Time Calculation",
              path: routes.payroll.OverTime,
            },
            {
              name: "Leave Encashment",
              path: routes.payroll.LeaveEncashment,
            },
            {
              name: "Employee Increment",
              path: routes.payroll.EmployeeIncrement,
            },
            // {
            //   name: "Arrear Calculation",
            //   path: routes.payroll.ArrearBaiseList,
            // },
          ],
        },
        {
          name: "Salary",
          children: [
            {
              name: "Salary Process",
              path: routes.salary.salaryProcess,
            },
            {
              name: "Salary Processed List",
              path: routes.salary.list,
            },
            {
              name: "Salary Sheet",
              path: routes.salary.salarySheetList,
            },
          ],
        },
      ],
    },
    {
      name: "TDS",
      icon: <TbFilePercent className="icons-dashboard me-2" />,
      children: [
        {
          name: "TDS Settings",
          children: [
            { name: "TDS Settings", path: routes.tds.TDSSettings },
            { name: "80C & US VI-A Items", path: routes.tds.TDSUSVIAItems },
            { name: "Type of Perks", path: routes.tds.TDSPerksMaster },
            {
              name: "TDS Calculation",
              path: routes.tds.TDSIncomeArrearExemption,
            },
          ],
        },
        {
          name: "TDS Return Process",
          children: [
            { name: "TDS Challan", path: routes.tds.TDSChallan },
            { name: "Company Details", path: routes.tds.TDSCompanyDetails },
          ],
        },
        {
          name: "TDS Decl./Invest.",
          children: [{ name: "Approver", path: routes.tds.TDSBaseWindow }],
        },
      ],
    },
    {
      name: "Loan & Advanced",
      icon: <BiSolidBank className="icons-dashboard me-2" />,
      children: [
        { name: "Dashboard", path: routes.loanAndAdvance.dashboard },
        {
          name: "Loan & Advanced Policy",
          path: routes.loanAndAdvance.loanAndPolicyList,
        },
        {
          name: "Loan Disbursement",
          path: routes.loanAndAdvance.loanDisbursementList,
        },
        { name: "Loan Finance", path: routes.loanAndAdvance.loanFinanceList },
        { name: "Loan Reports", path: routes.loanAndAdvance.loanReport },
      ],
    },

    {
      name: "Reimbursement",
      icon: <RiRefund2Line className="icons-dashboard me-2" />,
      children: [
        { name: "Reimb. Head", path: routes.reimbursement.sittingFaceWindow },
        {
          name: "Travel Budget & Policy",
          path: routes.reimbursement.travelBudgetPolicy,
        },
        {
          name: "Reimb. Approval Matrix",
          path: routes.reimbursement.approvalMatrix,
        },
        {
          name: "Accrued & Balance Details",
          path: routes.reimbursement.accuredBalancedDetails,
        },
        {
          name: "Reimb. Payment",
          path: routes.reimbursement.processAdminReimbursement,
        },
      ],
    },
    {
      name: "Exit",
      icon: <ImExit className="icons-dashboard me-2" />,
      children: [
        {
          name: "Exit Process",
          children: [
            { name: "Exit Type", path: routes.exit.exitType },
            {
              name: "Exit Clearance Department",
              path: routes.exit.exitClearanceDepartment,
            },
            {
              name: "Notice Days Settings",
              path: routes.exit.noticeDaysSetting,
            },
            { name: "Interview Incharge", path: routes.exit.interviewIncharge },
            {
              name: "Interview Questions",
              path: routes.exit.interviewQuestions,
            },
            {
              name: "Clearance Description",
              path: routes.exit.departmentClearance,
            },
          ],
        },
        {
          name: "F & F Process",
          children: [
            {
              name: "Exit Full & Final",
              path: routes.exitfullfinal.exitTypeFullAndFinal,
            },
          ],
        },
      ],
    },

    {
      name: "On Boarding",
      icon: <FaMoneyBillTrendUp className="icons-dashboard me-2" />,
      children: [
        { name: "Dashboard", path: routes.onBoarding.onBoardingDashboard },
        { name: "Letter Template", path: routes.onBoarding.letterTemplate },
        { name: "Generate Letter", path: routes.onBoarding.assignLetter },
        { name: "Offered Candidate List", path: routes.onBoarding.offeredList },
        {
          name: "Accepted List",
          path: routes.onBoarding.offeredAcceptCandidateList,
        },
        {
          name: "OnBoarding Approver",
          path: routes.onBoarding.onBoardingApprover,
        },
      ],
    },
    {
      name: "Admin Controls",
      icon: <IoGameController className="icons-dashboard me-2" />,
      children: [
        // users
        {
          name: "Users",
          children: [
            {
              name: "Admin User",
              path: routes.users.admin.roleList,
            },
            {
              name: "Roles",
              path: routes.users.ess.essRoleCreate,
            },
            {
              name: "Transfer & Assign Roles",
              path: routes.users.ess.assignRoles,
            },
            {
              name: "User Access",
              path: routes.users.ess.mobileRights,
            },
          ],
        },
        //mail
        {
          name: "Mail Communication",
          children: [
            {
              name: "Email Template",
              path: routes.mail.emailTemplate,
            },
            {
              name: "Mail Setting",
              path: routes.mail.mailSettting,
            },
            {
              name: "Third party  Mail Setting",
              path: routes.mail.ThirdPartymailSettting,
            },
            {
              name: "Mailer",
              path: routes.mail.mailer,
            },
          ],
        },
        {
          name: "Query Management",
          path: routes.queryManagement.queryManagementList,
        },
        {
          name: "Upload Controls",
          path: routes.controls.uploadControl,
        },
        {
          name: "Broadcast",
          path: routes.controls.broadcast,
        },

        {
          name: "Software Log Report",
          path: routes.controls.softwareLogReport,
        },
        {
          name: "Approval Setting",
          path: routes.controls.approvalSettingList,
        },
        {
          name: "Import Utility",
          path: routes.controls.importUtility,
        },
        {
          name: "Freeze Month",
          path: routes.freezeMonth,
        },
      ],
    },
  ],
};

export const ESS_SIDEBAR_NAV_MENU_ITEMS = {
  subMenu: [
    {
      name: "Dashboard",
      icon: <MdDashboard className="icons-dashboard me-2" />,
      path: routes.ess.dashboard,
    },
    {
      name: "Profile",
      icon: <CgProfile className="icons-dashboard me-2 " />,
      path: routes.ess.profile,
    },
    {
      name: "Attendance & Leave",
      icon: <GiArchiveRegister className="icons-dashboard me-2" />,
      children: [
        {
          name: "Shift",
          children: [
            {
              name: "Shift Ess",
              path: routes.ess.essShift.essEmployeeShiftList,
            },
            {
              name: "Shift Assign",
              path: routes.ess.essShift.essEmployeeShiftAssign,
            },
          ],
        },
        {
          name: "Leave",
          children: [
            {
              name: "Leave Request",
              path: routes.ess.attendance.leaveRequest,
            },
            {
              name: "Leave Approval",
              path: routes.ess.attendance.leaveApproval,
            },
            {
              name: "Leave Attendance Details",
              path: routes.ess.attendance.leaveAttendanceDetails,
            },
          ],
        },

        {
          name: "Attendance",
          children: [
            {
              name: "Mark Attendance",
              path: routes.ess.attendance.markAttendance,
            },
            {
              name: "Missed Punch",
              path: routes.ess.attendance.missedPunch,
            },
            {
              name: "Missed Punch Approver",
              path: routes.ess.attendance.missedPuchApprover,
            },
          ],
        },
      ],
    },
    {
      name: "Assets",
      icon: <GiPayMoney className="icons-dashboard me-2" />,
      children: [
        {
          name: "Request List",
          path: routes.ess.assets.list,
        },
        {
          name: "Assets Approver",
          path: routes.ess.assets.assetsApprovalList,
        },
        {
          name: "Assets Issued List",
          path: routes.ess.assets.issuedList,
        },
      ],
    },

    {
      name: "Exit ",
      icon: <ImExit className="icons-dashboard me-2" />,
      children: [
        {
          name: "Exit Process",
          children: [
            {
              name: "my Exit application",
              path: routes.ess.essExitProcess.employeeExitApplication,
            },
            {
              name: "Self Exit Clearance",
              path: routes.ess.essExitProcess.selfExitClearance,
            },
            {
              name: "Exit Interview",
              path: routes.ess.essExitProcess.exitInterviewEmail,
            },
          ],
        },
        {
          name: "Exit Approval Process",
          children: [
            {
              name: "my Exit approval",
              path: routes.ess.essExitProcess.employeeExitApproval,
            },
            {
              name: "Self Exit Approval",
              path: routes.ess.essExitProcess.selfExitClearanceApproval,
            },
            {
              name: "Exit Interview Approval",
              path: routes.ess.essExitProcess.approvalExitInterview,
            },
          ],
        },
      ],
    },

    {
      name: "Reimbursement ",
      icon: <RiRefund2Line className="icons-dashboard me-2" />,
      children: [
        {
          name: "Reimbursement Process",
          children: [
            {
              name: "Travel Request List",
              path: routes.ess.essReimbursementProcess.travelRequestList,
            },
            {
              name: "Other Misc. Claim",
              path: routes.ess.essReimbursementProcess.otherLtaTravelList,
            },
            {
              name: "LTA Claim",
              path: routes.ess.essReimbursementProcess.ltaClaimList,
            },
            {
              name: "Travel Claim Window",
              path: routes.ess.essReimbursementProcess.travelClaimWindowList,
            },
          ],
        },
        {
          name: "Reimbursement Approval Process",
          children: [
            {
              name: "Travel Request",
              path: routes.ess.essReimbursementProcess
                .travelRequestApprovalList,
            },
            {
              name: "HR and Admin",
              path: routes.ess.essReimbursementProcess.hrAdminApprovalList,
            },
            {
              name: "Travel Advanced(Finance)",
              path: routes.ess.essReimbursementProcess.financeDepartmentList,
            },
            {
              name: "Other Misc. Approval",
              path: routes.ess.essReimbursementProcess.otherLtaApprovedList,
            },
            {
              name: "Other Misc. Finance Approval",
              path: routes.ess.essReimbursementProcess
                .otherLtaFinanceApprovedList,
            },
            {
              name: "LTA Claim Approval",
              path: routes.ess.essReimbursementProcess.ltaClaimApprovedList,
            },
            {
              name: "LTA Finance Approval",
              path: routes.ess.essReimbursementProcess
                .ltaClaimFinanceApprovedList,
            },
            {
              name: "Travel Claim Approval",
              path: routes.ess.essReimbursementProcess
                .travelClaimWindowApproverList,
            },
            {
              name: "Travel Payment Process",
              path: routes.ess.essReimbursementProcess.travelPaymentProcessList,
            },
          ],
        },
      ],
    },
    {
      name: "TDS",
      icon: <TbFilePercent className="icons-dashboard me-2" />,
      children: [
        {
          name: "TDS Calculation",
          path: routes.ess.essTdsCalculationProcess.tdsCalculation,
        },
        {
          name: "TDS Approver",
          path: routes.ess.essTdsCalculationProcess.tdsApprover,
        },
        // {
        //   name: "TDS Return Process",
        //   path: routes.ess.essTdsCalculationProcess.tdsChallan,
        // },
      ],
    },

    // Loan And Advance Settings
    {
      name: "Loan & Advanced",
      icon: <BiSolidBank className="icons-dashboard me-2" />,
      children: [
        {
          name: "Loan Apply",
          path: routes.ess.loan.loanApply,
        },
        {
          name: "Loan Approve",
          path: routes.ess.loan.loanApprove,
        },
        {
          name: "Loan Finance",
          path: routes.ess.loan.loanFinanceList,
        },
        {
          name: "Loan Finance Approve",
          path: routes.ess.loan.loanFinanceApprover,
        },
        {
          name: "Emp. Loan & Adv. Details Report",
          path: routes.ess.loan.loanReport,
        },
        {
          name: "Approval Advanced Details Report",
          path: routes.ess.loan.loanApprovalReport,
        },
      ],
    },

    //ess OnBoarding
    {
      name: "On Boarding",
      icon: <FaMoneyBillTrendUp className="icons-dashboard me-2" />,
      children: [
        {
          name: "Generate Offer",
          path: routes.ess.essOnBoarding.onBoardingList,
        },
      ],
    },
  ],
};
